import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { useMutation } from 'react-query';

import { RequestAssistanceService } from '../services/request-assistance.service';

interface RequestAssistanceProps {
  classroomId: string;
  teacherId: number;
  notification: string;
}

export function useRequestAssistance() {
  const { environment } = useEnvironmentContext();

  const {
    mutateAsync: requestAssistance,
    isLoading: isRequestAssistanceLoading,
    isSuccess: isRequestAssistanceSuccess,
    reset: requestAssistanceReset,
  } = useMutation(
    async ({
      classroomId,
      teacherId,
      notification,
    }: RequestAssistanceProps) => {
      return await RequestAssistanceService.requestAssistance(
        environment,
        classroomId,
        teacherId,
        notification
      );
    }
  );

  return {
    requestAssistance,
    isRequestAssistanceLoading,
    isRequestAssistanceSuccess,
    requestAssistanceReset,
  };
}
